import { ReactSDKClient, createInstance } from '@optimizely/react-sdk';

const DEFAULT_EVENT_BATCH_SIZE = 10;
const DEFAULT_EVENT_FLUSH_INTERVAL = 1000;

function getPositiveNumberEnv(name: string, fallback: number) {
  const value = process.env[name];
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export const optimizelyClient: ReactSDKClient = createInstance({
  sdkKey: process.env.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY || '',
  logLevel: 'error',
  eventBatchSize: getPositiveNumberEnv(
    'NEXT_PUBLIC_OPTIMIZELY_EVENT_BATCH_SIZE',
    DEFAULT_EVENT_BATCH_SIZE
  ),
  eventFlushInterval: getPositiveNumberEnv(
    'NEXT_PUBLIC_OPTIMIZELY_EVENT_FLUSH_INTERVAL',
    DEFAULT_EVENT_FLUSH_INTERVAL
  ),
});
